import {
  List,
  Datagrid,
  ReferenceField,
  DateField,
  NumberField,
  ChipField,
  UrlField,
  ReferenceInput,
  SelectInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const OrderList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <ReferenceInput source="userId" reference="users" />,
      <ReferenceInput source="productId" reference="products" />,
      <SelectInput
        source="status"
        choices={[
          { id: 'pending', name: 'pending' },
          { id: 'paid', name: 'paid' },
          { id: 'refunded', name: 'refunded' },
        ]}
      />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <ReferenceField source="userId" reference="users" />
      <ReferenceField source="productId" reference="products" />
      <DateField source="purchasedAt" />
      <NumberField source="amountInCents" />
      <ChipField source="currency" />
      <UrlField source="purchaseLink" />
      <ChipField source="status" />
      <ReferenceField source="paymentRefernceId" reference="paymentRefernces" />
      <NumberField source="downloadLinksGenerated" />
      <DateField source="lastDownloadLinkGeneratedAt" />
    </Datagrid>
  </List>
)

export const OrderShow = () => (
  <Show>
    <SimpleShowLayout>
      <ReferenceField source="userId" reference="users" />
      <ReferenceField source="productId" reference="products" />
      <DateField source="purchasedAt" />
      <NumberField source="amountInCents" />
      <ChipField source="currency" />
      <UrlField source="purchaseLink" />
      <ChipField source="status" />
      <ReferenceField source="paymentRefernceId" reference="paymentRefernces" />
      <NumberField source="downloadLinksGenerated" />
      <DateField source="lastDownloadLinkGeneratedAt" />
    </SimpleShowLayout>
  </Show>
)
